import React from 'react';
import {Skeleton} from '@mui/material';
import {StyledCard} from 'presentation/components';
import {ILoadingStateProps} from './types';

export function LoadingState({widthSkeleton, p}: ILoadingStateProps) {
	return (
		<StyledCard.Container sx={{p: p || 0}}>
			<Skeleton sx={{my: 2, width: widthSkeleton || '100%'}} />
			<Skeleton sx={{my: 2}} />
			<Skeleton sx={{my: 2}} />
		</StyledCard.Container>
	);
}
